/**
 * Corrige o ShippingEstimator do tema Impact para usar a API síncrona
 * que funciona corretamente com Intelipost
 */
(function() {
  if (window.__SHIPPING_ESTIMATOR_FIX__) return;
  window.__SHIPPING_ESTIMATOR_FIX__ = true;

  function applyFix() {
    document.querySelectorAll('shipping-estimator').forEach(element => {
      // Sobrescreve o método _estimateShipping
      element._estimateShipping = async function() {
        const zipInput = this.querySelector('[name="shipping-estimator[zip]"]');
        const countryInput = this.querySelector('[name="shipping-estimator[country]"]');
        const provinceInput = this.querySelector('[name="shipping-estimator[province]"]');
        
        const zip = zipInput?.value || '';
        const country = countryInput?.value || 'BR';
        const province = provinceInput?.value || '';
        
        if (!zip) return;
        
        this.submitButton?.setAttribute("aria-busy", "true");
        
        try {
          // Usar API síncrona /cart/shipping_rates.json
          const qs = `shipping_address[zip]=${encodeURIComponent(zip)}&shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}`;
          const resp = await fetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}/shipping_rates.json?${qs}`, {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
          
          if (resp.status === 422) {
            this._formatError({ zip: ['CEP sem cobertura de frete'] });
            return;
          }
          
          if (!resp.ok) {
            this._formatError({ error: ['Erro ao calcular frete'] });
            return;
          }
          
          const data = await resp.json();
          
          if (!data?.shipping_rates) {
            this._formatError({ error: ['Nenhuma opção disponível'] });
            return;
          }
          
          this._formatShippingRates(data.shipping_rates);
        } catch (e) {
          console.error('[ShippingEstimator]', e);
          this._formatError({ error: ['Erro de conexão'] });
        } finally {
          this.submitButton?.removeAttribute("aria-busy");
        }
      };
    });
  }

  // Aplica o fix quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }

  // Observa novos elementos shipping-estimator
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeName === 'SHIPPING-ESTIMATOR') {
          setTimeout(applyFix, 10);
        }
      });
    });
  });
  
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
